/*
 * @Descripttion:
 * @version:
 * @Author: wupeng
 * @Date: 2019-09-03 08:21:15
 * @LastEditors: zc
 * @LastEditTime: 2024-10-23 16:01:45
 */
import { service, fileService, formService } from '@/data/index';
import { emesBaseUrl } from '@/config';
/**\
 * 新增保存学生信息
 * @param data
 * @returns {*}
 */

export function saveStudentInfo(data) {
  return service.post('school/student/add', data);
}
/**\
 * 修改保存学生信息
 * @param data
 * @returns {*}
 */

export function updateStudentInfo(data) {
  return service.post('school/student/update', data);
}
/**
 * 学生信息详情
 * @param data
 * @returns {*}
 */

export function studentDetail(data) {
  return service.post('school/student/get', data);
}
/**
 * 获取年级班级级联数据
 * @param data
 * @returns {*}
 */

export function getGradeClassList(data) {
  return service.get('school/grade/gradeClassList', data);
}
/**
 * 学生信息列表
 * @param data
 */

export function getStudentList(data) {
  return service.get('school/student/list', data);
}
/**
 * 学生禁用启用
 * @param data
 */

export function changeStatusStudent(data) {
  return service.get('school/student/updateState', data);
}
/**
 * 学生转班
 * @param data
 */

export function saveChangeStudent(data) {
  return service.post('school/student/updateClass', data);
}
/**
 * 转班学生列表数据
 * @param data
 */

export function getStudentListNoPage(data) {
  return service.get('school/student/listByClassId', data);
}
/**
 * 学生批量删除
 * @param data
 */

export function deleteStudent(data) {
  return service.post('school/student/deleteBatch', data);
}
/**
 * @function resetStudentPwd 批量重置密码
 * @param data  参数对象{ids: '11,22'}
 * @returns {*}
 */

export function resetStudentPwd(data) {
  return service.post('school/student/updatePassword', data);
}
/**
 * @function importStudentFile 学生信息批量导入
 * @param data  参数对象{}
 * @returns {*}
 */

export function importStudentFile(data) {
  return fileService({
    url: 'school/student/importNew',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * @description 通过文件导入学生信息
 * @param {file: file, type: int} data
 * @returns {*}
 */

export function importStudentInfoByFile(data) {
  return fileService({
    url: 'school/student/import',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * @description 确认导入学生
 * @param {json} data
 * @returns {*}
 */

export function confirmImportStudent(data) {
  return service.post('school/student/import/confirm', data);
}
/**
 * @function importStudentFile 学生身份证信息批量导入
 * @param data  参数对象{}
 * @returns {*}
 */

export function importStudentIdCardFile(data) {
  return fileService({
    url: 'school/student/importIdCard',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * @description 学生转班导入
 * @param {*} data
 * @returns
 */

export function studentChangeClass(data) {
  return fileService({
    url: 'school/student/classTransfer/import',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * 根据学籍号、姓名、性别查询学生信息
 * @function transferStudentInfo
 * @param data  参数对象{}
 * @returns {*}
 */

export function transferStudentInfo(data) {
  return service.get('school/transfer/queryStudentInfo', data);
}
/**
 * 学生转校
 * @function saveStudentTransfer
 * @param data  参数对象{}
 * @returns {*}
 */

export function saveStudentTransfer(data) {
  return service.get('school/transfer/updateStudentTransfer', data);
}
/**
 * 根据orgCode  获取转入学生数据
 * @param data   参数对象{}
 * @returns {*}
 */

export function getDestOrgCode(data) {
  return service.get('school/transfer/getDestOrgCode', data);
}
/**
 * 根据orgCode  获取转出学生数据
 * @param data   参数对象{}
 * @returns {*}
 */

export function getOriOrgCode(data) {
  return service.get('school/transfer/getOriOrgCode', data);
}
/**
 * 根据id查询转校学生信息
 * @param data   参数对象{}
 * @returns {*}
 */

export function getStudentTransferSchool(data) {
  return service.get('school/transfer/getStudentTransferSchool', data);
}
/*
 *  导出学生信息
 */

export function dowLoadStudentUser(data) {
  return formService({
    responseType: 'blob',
    url: '/export/to/dowLoadStudentAndParentUser',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/*
 *  导出学生信息
 */

export function dowLoadIdCardInfo(data) {
  return formService({
    responseType: 'blob',
    url: '/export/to/dowLoadIdCardInfo',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/*
 *  导出学生模板
 */

export function dowLoadTest(data) {
  return formService({
    responseType: 'blob',
    url: '/export/to/dowLoadTest',
    data: data,
    method: 'post',
    timeout: 60 * 60 * 1000
  });
}
/**
 * 查询授权过的学生列表
 * @param data
 */

export function queryAuthStudent(data) {
  return service({
    baseURL: emesBaseUrl,
    url: 'evaluation/student/getEvaluationStudentAuth',
    method: 'post',
    data: data
  });
}
/**
 * 查询可以解除测评授权的列表
 * @param data
 */

export function queryDeleteAuth(data) {
  return service({
    baseURL: emesBaseUrl,
    url: 'evaluation/student/getDeleteAuth',
    method: 'post',
    data: data
  });
}
/**
 * 解除测评授权操作
 * @param data
 */

export function deleteEvaluationStudentAuth(data) {
  return service({
    baseURL: emesBaseUrl,
    url: 'evaluation/student/deleteEvaluationStudentAuth',
    method: 'post',
    data: data
  });
}